import { render, staticRenderFns } from "./BetSettingMenu.vue?vue&type=template&id=788aa903&"
import script from "./BetSettingMenu.vue?vue&type=script&lang=js&"
export * from "./BetSettingMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports